var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"name":"keep-alive"}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('wx-loading',{attrs:{"show":_vm.showLoadingPic,"loadingText":_vm.$t('lang.loadingText')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }